module.exports = __webpack_public_path__ + "static/img/20190517121807.d92142e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20190517121807.jpg
// module id = ypkB
// module chunks = 1